import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const _calculateCCMaxLength = (cardType) => {
    /* istanbul ignore else */
    if (cardType === 'amex') {
        return '17';
    }
    /* istanbul ignore else */
    if (cardType === 'dinersClub') {
        return '16';
    }
    /* istanbul ignore else */
    if (cardType === 'unionPay') {
        return '20';
    }
    return '19';
};
/* For Date Field */
const _calculateDateMaxLength = (dateFormat) => {
    /* istanbul ignore else */
    if (dateFormat === 'mmyy') {
        return '5';
    }
    /* istanbul ignore else */
    if (dateFormat === 'mmddyy') {
        return '8';
    }
    return '10';
};
const _calculateMaxLength = (cardType, type, dateFormat, cardBrand, maxLength) => {
    switch (type) {
        case 'creditCard':
            return _calculateCCMaxLength(cardType);
        case 'tel':
            return 12;
        case 'date':
            return _calculateDateMaxLength(dateFormat);
        /* case 'taxID':
          return hidden ? '9' : format === 'ssn' ? '11' : '10'; */
        case 'securityCode':
            /* istanbul ignore else */
            if (cardBrand !== undefined &&
                cardBrand !== 'amex' &&
                cardBrand !== 'other') {
                return 3;
            }
            return 4;
        default:
            return maxLength || 'none';
    }
};
const _ignoreAlpha = (e) => {
    const cursor = e.target.selectionStart;
    const match = e.target.value.match(/[^0-9/\s/-]*/g);
    match.forEach((item, index) => {
        /* istanbul ignore else */
        if (item !== '') {
            e.target.value =
                e.target.value.substring(0, index) +
                    e.target.value.substring(index + 1, e.target.value.length);
            e.target.setSelectionRange(cursor - 1, cursor - 1);
        }
    });
    return e.target.value;
};
const _onlyNumbers = (e) => {
    const cursor = e.target.selectionStart;
    const match = e.target.value.match(/[^0-9]*/g);
    match.forEach((item, index) => {
        /* istanbul ignore else */
        if (item !== '') {
            e.target.value =
                e.target.value.substring(0, index) +
                    e.target.value.substring(index + 1, e.target.value.length);
            e.target.setSelectionRange(cursor - 1, cursor - 1);
        }
    });
    return e.target.value;
};
const _maskValue = (value) => {
    /* istanbul ignore else */
    if (!value)
        return;
    const last = value.substring(value.length - 4);
    let dots = '';
    const dotLength = value.replace(/\D/g, '').length - 4;
    /* istanbul ignore else */
    if (value.length > 13) {
        while (dots.length < dotLength * 2) {
            dots += '• ';
        }
        dots += last;
    }
    return dots;
};
const ccFormat = (clean) => {
    let match;
    /* istanbul ignore else */
    if (clean.length < 5) {
        match = clean.match(/^(\d{1,4})$/);
    }
    else if (clean.length < 9) {
        match = clean.match(/^(\d{4})(\d{1,4})$/);
    }
    else if (clean.length < 13) {
        match = clean.match(/^(\d{4})(\d{4})(\d{1,4})$/);
    }
    else {
        match = clean.match(/^(\d{4})(\d{4})(\d{4})(\d{1,4})$/);
    }
    return match;
};
const _determineCard = (e, clean) => {
    let cardType;
    let match;
    const firstNum = parseInt(clean.substring(0, 1), 10);
    const twoChar = parseInt(clean.substring(0, 2), 10);
    const threeChar = parseInt(clean.substring(0, 3), 10);
    const fourChar = parseInt(clean.substring(0, 4), 10);
    const sixChar = parseInt(clean.substring(0, 6), 10);
    /* istanbul ignore else */
    if (firstNum === 4) {
        /* istanbul ignore else */
        if (clean.length < 5) {
            match = clean.match(/^(\d{1,4})$/);
        }
        else if (clean.length < 9) {
            match = clean.match(/^(\d{4})(\d{1,4})$/);
        }
        else if (clean.length < 13) {
            match = clean.match(/^(\d{4})(\d{4})(\d{1,4})$/);
        }
        else {
            match = clean.match(/^(\d{4})(\d{4})(\d{4})(\d{1,7})$/);
        }
        cardType = 'visa';
    }
    else if (twoChar === 34 || twoChar === 37) {
        /* istanbul ignore else */
        if (clean.length < 5) {
            match = clean.match(/^(\d{1,4})$/);
        }
        else if (clean.length < 11) {
            match = clean.match(/^(\d{4})(\d{1,6})$/);
        }
        else {
            match = clean.match(/^(\d{4})(\d{6})(\d{1,5})$/);
        }
        cardType = 'amex';
    }
    else if (
    // twoChar === 62 ||
    twoChar === 62 ||
        twoChar === 81 ||
        (twoChar === 60 && fourChar !== 6011)) {
        /* istanbul ignore else */
        if (clean.length < 5) {
            match = clean.match(/^(\d{1,4})$/);
        }
        else if (clean.length < 9) {
            match = clean.match(/^(\d{4})(\d{1,4})$/);
        }
        else if (clean.length < 13) {
            match = clean.match(/^(\d{4})(\d{4})(\d{1,4})$/);
        }
        else if (clean.length < 17) {
            match = clean.match(/^(\d{4})(\d{4})(\d{4})(\d{1,4})$/);
        }
        else if (clean.length === 17 || clean.length === 18) {
            match = clean.match(/^(\d{1,18})$/);
        }
        else if (clean.length === 19) {
            match = clean.match(/^(\d{6})(\d{1,13})$/);
        }
        cardType = 'unionPay';
    }
    else if ((threeChar > 299 && threeChar <= 305) ||
        threeChar === 309 ||
        twoChar === 36 ||
        twoChar === 38 ||
        twoChar === 39) {
        /* istanbul ignore else */
        if (clean.length < 5) {
            match = clean.match(/^(\d{1,4})$/);
        }
        else if (clean.length < 11) {
            match = clean.match(/^(\d{4})(\d{1,6})$/);
        }
        else {
            match = clean.match(/^(\d{4})(\d{6})(\d{1,4})$/);
        }
        cardType = 'dinersClub';
    }
    else if (fourChar === 6011 ||
        (threeChar >= 644 && threeChar <= 649) ||
        twoChar === 65) {
        match = ccFormat(clean);
        cardType = 'discover';
    }
    else if (fourChar >= 3528 && fourChar <= 3589) {
        match = ccFormat(clean);
        cardType = 'jcb';
    }
    else if ((twoChar >= 51 && twoChar <= 55) ||
        (sixChar >= 222100 && sixChar <= 272099)) {
        match = ccFormat(clean);
        cardType = 'mastercard';
    }
    else if (clean.length < 6) {
        match = ccFormat(clean);
        cardType = undefined;
    }
    else {
        match = ccFormat(clean);
        cardType = 'other';
    }
    return { match, cardType };
};
const creditCardOnChange = (e, stateValue) => {
    let targetValue = e.target.value;
    let start = e.target.selectionStart;
    e.target.selectionEnd;
    let clean = targetValue.replace(/\D/g, '');
    let obj = _determineCard(e, clean);
    let { cardType } = obj;
    const current = targetValue[start - 1];
    if (current === ' ' && start < targetValue.length) {
        // prevents space keypress from moving the cursor
        start -= 1;
    }
    else if (stateValue === undefined ||
        stateValue.length < targetValue.length) {
        // move cursor forward when coming across a space
        if (cardType === 'amex' || cardType === 'dinersClub') {
            /* istanbul ignore else */
            if (start === 5 || start === 12) {
                start += 1;
            }
        }
        else if (start % 5 === 0 && start < 16) {
            start += 1;
        }
    }
    else if (stateValue.length > targetValue.length &&
        stateValue[start] === ' ') {
        // remove leading number when backspacing over a space
        targetValue =
            targetValue.slice(0, start - 1) +
                targetValue.slice(start, targetValue.length);
        start -= 1;
    }
    clean = targetValue.replace(/\D/g, '');
    obj = _determineCard(e, clean);
    const { match } = obj;
    if (match && match[4]) {
        e.target.value = `${match[1]} ${match[2]} ${match[3]} ${match[4]}`;
    }
    else if (match && match[3]) {
        e.target.value = `${match[1]} ${match[2]} ${match[3]}`;
    }
    else if (match && match[2]) {
        e.target.value = `${match[1]} ${match[2]}`;
    }
    else if (match && match[1]) {
        // eslint-disable-next-line prefer-destructuring
        e.target.value = match[1];
    }
    else {
        cardType = undefined;
    }
    return {
        value: e.target.value.replace(/[^0-9\s]*/g, ''),
        cardType,
    };
};
const phoneMatchPattern = (clean) => {
    let match;
    /* istanbul ignore else */
    if (clean.length > 6) {
        match = clean.match(/^(\d{3})(\d{3})(\d{1,4})$/);
    }
    else if (clean.length > 3) {
        match = clean.match(/^(\d{3})(\d{1,3})$/);
    }
    else if (clean.length > 0) {
        match = clean.match(/^\d{1,3}$/);
    }
    return match;
};
const dashPhoneFormat = (target, match) => {
    const newTarget = target;
    if (match && match[3]) {
        newTarget.value = `${match[1]}-${match[2]}-${match[3]}`;
    }
    else if (match && match[2]) {
        if (match[2].length === 3) {
            newTarget.value = `${match[1]}-${match[2]}-`;
        }
        else {
            newTarget.value = `${match[1]}-${match[2]}`;
        }
    }
    else if (match) {
        if (match[0].length === 3) {
            newTarget.value = `${match[0]}-`;
        }
        else {
            // eslint-disable-next-line prefer-destructuring
            newTarget.value = match[0];
        }
    }
    else {
        newTarget.value = '';
    }
};
const addToCursor = (start, end) => {
    let newStart = start;
    let newEnd = end;
    newStart += 1;
    newEnd += 1;
    return [newStart, newEnd];
};
const subtractToCursor = (start, end) => {
    let newStart = start;
    let newEnd = end;
    newStart -= 1;
    newEnd -= 1;
    return [newStart, newEnd];
};
const _formatToPhoneDash = (e, stateValue) => {
    const { target } = e;
    const clean = target.value.replace(/\D/g, '');
    const cleanStateValue = stateValue.replace(/\D/g, '');
    let match;
    let start = target.selectionStart;
    let end = target.selectionEnd;
    if (stateValue.length > target.value.length && stateValue[start] === '-') {
        target.value =
            target.value.slice(0, start - 1) +
                target.value.slice(start, target.value.length);
        const s = target.value.replace(/\D/g, '');
        match = phoneMatchPattern(s);
        [start, end] = subtractToCursor(start, end);
        dashPhoneFormat(target, match);
    }
    else if (clean.length <= cleanStateValue.length) {
        let s = target.value.substring(0, target.selectionStart) +
            target.value.slice(target.selectionStart, target.value.length);
        s = s.replace(/\D/g, '');
        match = phoneMatchPattern(s);
        dashPhoneFormat(target, match);
    }
    else if (clean.length > cleanStateValue.length) {
        match = phoneMatchPattern(clean);
        if (match && match[3]) {
            target.value = `${match[1]}-${match[2]}-${match[3]}`;
            /* istanbul ignore else */
            if (start === 4 || start === 8) {
                [start, end] = addToCursor(start, end);
            }
        }
        else if (match && match[2]) {
            if (target.value.length >= 7) {
                target.value = `${match[1]}-${match[2]}-`;
            }
            else {
                target.value = `${match[1]}-${match[2]}`;
            }
            /* istanbul ignore else */
            if (start === 4 || start === 7) {
                [start, end] = addToCursor(start, end);
            }
        }
        else if (match) {
            if (target.value.length >= 3) {
                target.value = `${match[0]}-`;
            }
            else {
                // eslint-disable-next-line prefer-destructuring
                target.value = match[0];
            }
            /* istanbul ignore else */
            if (start === 3) {
                [start, end] = addToCursor(start, end);
            }
        }
        else {
            target.value = '';
        }
    }
    else {
        match = phoneMatchPattern(cleanStateValue);
        dashPhoneFormat(target, match);
        [start, end] = subtractToCursor(start, end);
    }
    target.setSelectionRange(start, end);
    return {
        value: target.value,
    };
};
const stickyPlaceholderHTML = (dateFormat, value) => {
    const clean = value.replace(/\D/g, '');
    const [firstNum, secondNum, thirdNum, fourthNum, fifthNum, sixthNum, seventhNum, eighthNum,] = clean;
    const formatDate = (parts, suffix) => (jsxs(Fragment, { children: [jsx("span", { children: parts.join('') }), suffix && suffix] }));
    switch (dateFormat) {
        case 'mmyy':
            if (fourthNum)
                return formatDate([firstNum, secondNum, '/', thirdNum, fourthNum]);
            if (thirdNum)
                return formatDate([firstNum, secondNum, '/', thirdNum], 'Y');
            if (secondNum)
                return formatDate([firstNum, secondNum, '/'], 'YY');
            if (firstNum)
                return formatDate([firstNum], 'M/YY');
            return 'MM/YY';
        case 'mmddyy':
            if (sixthNum)
                return formatDate([
                    firstNum,
                    secondNum,
                    '/',
                    thirdNum,
                    fourthNum,
                    '/',
                    fifthNum,
                    sixthNum,
                ]);
            if (fifthNum)
                return formatDate([firstNum, secondNum, '/', thirdNum, fourthNum, '/', fifthNum], 'Y');
            if (fourthNum)
                return formatDate([firstNum, secondNum, '/', thirdNum, fourthNum, '/'], 'YY');
            if (thirdNum)
                return formatDate([firstNum, secondNum, '/', thirdNum], 'D/YY');
            if (secondNum)
                return formatDate([firstNum, secondNum, '/'], 'DD/YY');
            if (firstNum)
                return formatDate([firstNum], 'M/DD/YY');
            return 'MM/DD/YY';
        default: // Default to 'MM/DD/YYYY'
            if (eighthNum)
                return formatDate([
                    firstNum,
                    secondNum,
                    '/',
                    thirdNum,
                    fourthNum,
                    '/',
                    fifthNum,
                    sixthNum,
                    seventhNum,
                    eighthNum,
                ]);
            if (seventhNum)
                return formatDate([
                    firstNum,
                    secondNum,
                    '/',
                    thirdNum,
                    fourthNum,
                    '/',
                    fifthNum,
                    sixthNum,
                    seventhNum,
                ], 'Y');
            if (sixthNum)
                return formatDate([
                    firstNum,
                    secondNum,
                    '/',
                    thirdNum,
                    fourthNum,
                    '/',
                    fifthNum,
                    sixthNum,
                ], 'YY');
            if (fifthNum)
                return formatDate([firstNum, secondNum, '/', thirdNum, fourthNum, '/', fifthNum], 'YYY');
            if (fourthNum)
                return formatDate([firstNum, secondNum, '/', thirdNum, fourthNum, '/'], 'YYYY');
            if (thirdNum)
                return formatDate([firstNum, secondNum, '/', thirdNum], 'D/YYYY');
            if (secondNum)
                return formatDate([firstNum, secondNum, '/'], 'DD/YYYY');
            if (firstNum)
                return formatDate([firstNum], 'M/DD/YYYY');
            return 'MM/DD/YYYY';
    }
};
const _checkMonthValue = (month) => {
    if (month.length === 1) {
        return /^([01])$/.test(month) ? month : '';
    }
    if (month.length === 2) {
        return /^(0[1-9]|1[0-2])$/.test(month) ? month : month[0];
    }
    return '';
};
const _checkDateValue = (date) => {
    if (date.length === 1) {
        return /^([0-3])$/.test(date) ? date : '';
    }
    if (date.length === 2) {
        return /^(0[1-9]|[12][0-9]|3[01])$/.test(date) ? date : date[0];
    }
    return '';
};
const dateOnChange = (e, stateValue, dateFormat) => {
    const { target } = e;
    let clean = target.value.replace(/\D/g, ''); // Remove all non-numeric characters
    let start = target.selectionStart;
    let end = target.selectionEnd;
    const cleanState = stateValue.replace(/\D/g, ''); // Clean previous state value
    // Adjust cursor position when adding or deleting characters
    if (cleanState.length < clean.length) {
        if (start === 3 || start === 6) {
            start += 1;
            end += 1;
        }
    }
    else if (start === 2 || start === 5) {
        target.value =
            target.value.slice(0, start - 1) +
                target.value.slice(start, target.value.length);
        start -= 1;
        end -= 1;
    }
    // Reformat the input
    clean = target.value.replace(/\D/g, '');
    let formattedValue = '';
    if (clean.length > cleanState.length) {
        if (dateFormat === 'mmddyy') {
            if (clean.length > 4) {
                formattedValue = `${_checkMonthValue(clean.slice(0, 2))}/${_checkDateValue(clean.slice(2, 4))}/${clean.slice(4, 6)}`;
            }
            else if (clean.length === 4) {
                const date = _checkDateValue(clean.slice(2, 4));
                formattedValue = `${_checkMonthValue(clean.slice(0, 2))}/${date}${date.length === 2 ? '/' : ''}`;
            }
            else if (clean.length === 3) {
                formattedValue = `${_checkMonthValue(clean.slice(0, 2))}/${_checkDateValue(clean.slice(2, 4))}`;
            }
            else if (clean.length === 2) {
                const month = _checkMonthValue(clean);
                formattedValue = month.length === 2 ? `${month}/` : month;
            }
            else {
                formattedValue = _checkMonthValue(clean);
            }
        }
        else if (dateFormat === 'mmddyyyy') {
            if (clean.length > 4) {
                formattedValue = `${_checkMonthValue(clean.slice(0, 2))}/${_checkDateValue(clean.slice(2, 4))}/${clean.slice(4, 8)}`;
            }
            else if (clean.length === 4) {
                const date = _checkDateValue(clean.slice(2, 4));
                formattedValue = `${_checkMonthValue(clean.slice(0, 2))}/${date}${date.length === 2 ? '/' : ''}`;
            }
            else if (clean.length === 3) {
                formattedValue = `${_checkMonthValue(clean.slice(0, 2))}/${_checkDateValue(clean.slice(2, 4))}`;
            }
            else if (clean.length === 2) {
                const month = _checkMonthValue(clean);
                formattedValue = month.length === 2 ? `${month}/` : month;
            }
            else {
                formattedValue = _checkMonthValue(clean);
            }
        }
        else if (dateFormat === 'mmyy') {
            if (clean.length > 2) {
                formattedValue = `${_checkMonthValue(clean.slice(0, 2))}/${clean.slice(2, 4)}`;
            }
            else if (clean.length === 2) {
                const month = _checkMonthValue(clean);
                formattedValue = clean.length === 2 ? `${month}/` : month;
            }
            else {
                formattedValue = _checkMonthValue(clean);
            }
        }
    }
    else if (clean.length < cleanState.length) {
        if (dateFormat === 'mmddyy') {
            if (clean.length > 4) {
                formattedValue = `${clean.slice(0, 2)}/${clean.slice(2, 4)}/${clean.slice(4, 6)}`;
            }
            else if (clean.length === 4) {
                formattedValue = `${clean.slice(0, 2)}/${clean.slice(2, 4)}/`;
            }
            else if (clean.length === 3) {
                formattedValue = `${clean.slice(0, 2)}/${clean.slice(2, 4)}`;
            }
            else if (clean.length === 2) {
                formattedValue = `${clean}/`;
            }
            else {
                formattedValue = clean;
            }
        }
        else if (dateFormat === 'mmddyyyy') {
            if (clean.length > 4) {
                formattedValue = `${clean.slice(0, 2)}/${clean.slice(2, 4)}/${clean.slice(4, 8)}`;
            }
            else if (clean.length === 4) {
                formattedValue = `${clean.slice(0, 2)}/${clean.slice(2, 4)}/`;
            }
            else if (clean.length === 3) {
                formattedValue = `${clean.slice(0, 2)}/${clean.slice(2, 4)}`;
            }
            else if (clean.length === 2) {
                formattedValue = `${clean}/`;
            }
            else {
                formattedValue = clean;
            }
        }
        else if (dateFormat === 'mmyy') {
            if (clean.length > 2) {
                formattedValue = `${clean.slice(0, 2)}/${clean.slice(2, 4)}`;
            }
            else if (clean.length === 2) {
                formattedValue = `${clean}/`;
            }
            else {
                formattedValue = clean;
            }
        }
    }
    // Update the input value and cursor position
    target.value = formattedValue;
    // Ensure the cursor skips over the `/`
    if (start === 2 || start === 5) {
        start += 1;
        end += 1;
    }
    target.setSelectionRange(start, end);
    return {
        value: formattedValue, // Return the formatted value
    };
};

export { _calculateCCMaxLength, _calculateDateMaxLength, _calculateMaxLength, _checkDateValue, _checkMonthValue, _determineCard, _formatToPhoneDash, _ignoreAlpha, _maskValue, _onlyNumbers, creditCardOnChange, dateOnChange, stickyPlaceholderHTML };
